module.exports = __webpack_public_path__ + "static/media/monetization_on_black_24dp.6940922a.svg";